import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/LOGO.png";
import { Link, redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Language from "./Language";

function NavMUI({ executeScroll, executeScrollContact, executeScrollAboutus }) {
  const { t } = useTranslation();
  const [collapseclass, setcollapseclass] = useState("block");

  return (
    <div className="nav-main">
      <nav
        className="navbar navbar-expand-lg bg-body-tertiary"
        style={{ backgroundColor: "white" }}
      >
        <div className="container-fluid">
          <Link to={`/`} className="nav-resp-logo">
            <img src={logo} alt="Logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            id="collapsebtn"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            // onClick={clickfn}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse test"
            id="navbarSupportedContent"
          >
            <div className="search-link">
              <Link to={`/`} className="nav-resp-logo2">
                <img src={logo} alt="Logo" />
              </Link>
              {/* <SearchDropdown /> */}
              <ul className="navbar-nav me-auto mb-2 mb-lg-0 ul-custom">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    onClick={executeScroll}
                  >
                    <span className="navtext"> {t("Courses")}</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    target=""
                    // to="http://www.m2elearning.com/front/about_us"
                    onClick={executeScrollAboutus}
                  >
                    <span className="navtext"> {t("About us")}</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    onClick={executeScrollContact}
                  >
                    <span className="navtext"> {t("Contact us")}</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="log-link">
              <div className="lang-div-component">
                <Language/>
              </div>
              <Link
                className="btn btn-outline-primary form-custom custom-1"
                style={{ display: collapseclass, transition: "0.5s ease" }}
                to="http://www.m2elearning.com/front/login"
                target="_blank"
              >
                {t("Login")}
              </Link>
              <Link
                className="btn btn-primary form-custom custom-2"
                style={{ display: collapseclass, transition: "0.5s ease" }}
                to="http://www.m2elearning.com/front/signup"
                target="_blank"
              >
                {t("Register")}
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default NavMUI;
